import { useTranslation } from 'react-i18next';
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
    Typography,
} from '@material-ui/core';
import DebouncedTextField from '@commonClient2/components/DebouncedTextField';

const InputTitle = (props) => (
    <Typography
        component="p"
        className="input-label"
        {...props}
    >
        {props.children}
    </Typography>
);

const InputDisclaimer = (props) => (
    <p {...props}>
        <small className="input-disclaimer">
            {props.children}
        </small>
    </p>
);

/**
 * @param {{
 *  stepIndex: number
 *  validationErrors: {[Key: string] : boolean | string}
 *  errorRef: import('react').MutableRefObject<HTMLInputElement>
 *  formData: any
 *  updateFormData: Function
 * }} props
 */
function InformationSection({ stepIndex, validationErrors, errorRef, formData, updateFormData }) {
    const { t } = useTranslation('notificationTemplates');

    return (
        <Card className="card">
            <CardHeader
                ref={errorRef}
                className="card--header"
                gutterbottom
                avatar={<Avatar className="avatar">{stepIndex}</Avatar>}
                title={t('sidePanel.informationSection.title')}
            />
            <CardContent>
                <div>
                    <InputTitle>{t('sidePanel.informationSection.nameLabel')}</InputTitle>
                    <DebouncedTextField
                        error={validationErrors.name}
                        value={formData.name}
                        onChange={(event) => updateFormData('name', event.target.value)}
                        inputProps={{ maxLength: 50 }}
                        placeholder={t('sidePanel.informationSection.namePlaceholder')}
                        variant="outlined"
                        fullWidth
                    />
                    {
                        validationErrors.name && (
                            <span style={{ color: 'red' }}>{validationErrors.nameErrorMessage}</span>)
                    }
                    <InputDisclaimer>{t('sidePanel.informationSection.nameDisclaimer')}</InputDisclaimer>
                </div>

                <div>
                    <InputTitle>{t('sidePanel.informationSection.descriptionLabel')}</InputTitle>
                    <DebouncedTextField
                        value={formData.description}
                        onChange={(event) => updateFormData('description', event.target.value)}
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 250 }}
                        placeholder={t('sidePanel.informationSection.descriptionPlaceholder')}
                        variant="outlined"
                        fullWidth
                    />
                    <InputDisclaimer>{t('sidePanel.informationSection.descriptionDisclaimer')}</InputDisclaimer>
                </div>
            </CardContent>
        </Card>
    );
}

export default InformationSection;

